import { DefaultSidebar } from "@excalidraw/excalidraw";

/** One native panel and trigger for Search and Library, independent of its active tab. */
export default function EditorSidePanel() {
  return (
    <>
      <DefaultSidebar.Trigger title="Side panel" tab="library" icon={sidePanelIcon} />
      <DefaultSidebar docked onDock={false} />
    </>
  );
}

const sidePanelIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <path d="M15 4v16" />
  </svg>
);
